<template>
    <div class="container-fluid mt-5">
        <div class="row">
            <div class="col-md-12 text-center">
                <h3>Pacientes con Más Visitas</h3>
                <p class="text-muted">Visualiza los pacientes que más te han visitado.</p>
            </div>
            <div class="col-md-12 text-center">
                <div v-if="isLoading">
                    <vs-spinner color="rgb(59,222,200)" />
                </div>
                <div v-else>
                    <apexchart type="bar" :options="chartOptions" :series="chartSeries" height="350" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import axios from "axios";
var config = require("@/config/api.json");
const API = config.api;

export default {
    name: "PacienteMasVisitas", // Changed component name
    components: {
        apexchart: VueApexCharts
    },
    props: {
        personal_medico_id: {
            type: [String, Number],
            required: true
        }
    },
    data() {
        return {
            isLoading: true,
            chartOptions: {
                chart: {
                    type: "bar"
                },
                xaxis: {
                    categories: [] // Nombres de los pacientes
                },
                yaxis: {
                    title: {
                        text: "Total Visitas" // Changed y-axis title
                    }
                },
                colors: ["#ffcd56"], // Changed color for differentiation
                plotOptions: {
                    bar: {
                        horizontal: true
                    }
                },
                tooltip: {
                    y: {
                        formatter: function (val) {
                            return `${val} visitas`; // Changed tooltip text
                        }
                    }
                }
            },
            chartSeries: []
        };
    },
    mounted() {
        this.fetchPacientesMasVisitas(); // Changed method call
    },
    methods: {
        // Renamed method and updated endpoint and data processing
        async fetchPacientesMasVisitas() {
            this.isLoading = true; // Ensure loading state is true at the start
            try {
                const response = await axios.get(`${API}/paciente_con_mas_visitas`, { // Changed endpoint
                    params: {
                        personal_medico_id: this.personal_medico_id
                    }
                });

                if (response.data.status === "success") {
                    const data = response.data.data;
                    // Use patient names for categories and total visits for data
                    this.chartOptions = {
                        ...this.chartOptions, // Preserve other options
                        xaxis: {
                            ...this.chartOptions.xaxis,
                            categories: data.map(item => item.nombre)
                        }
                    };
                    this.chartSeries = [
                        {
                            name: "Visitas", // Changed series name
                            data: data.map(item => item.total_visitas) // Use total_visitas
                        }
                    ];
                } else {
                    // Updated error message
                    this.notify("error", "No se pudo obtener los pacientes con más visitas.");
                }
            } catch (error) {
                console.error(error);
                // Updated error message
                this.notify("error", `Error al obtener pacientes: ${error.response?.data?.message || error.message}`);
            } finally {
                this.isLoading = false;
            }
        },
        // Assuming notify method exists in the parent or globally
        notify(type, message) {
            // Placeholder for notification logic (e.g., using a library like vue-notifications or vuesax notifications)
            console.log(`Notification (${type}): ${message}`);
             if (this.$vs && this.$vs.notify) {
                 this.$vs.notify({
                     title: type === 'error' ? 'Error' : 'Éxito',
                     text: message,
                     color: type === 'error' ? 'danger' : 'success',
                     position: 'top-right'
                 });
             }
        }
    }
};
</script>

<style scoped>
/* Styles can be reused or adapted as needed */
.text-main-gradient {
    background: linear-gradient(to right, #40a5ff, #ffcd56);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}
</style>
